import React from 'react';
import imgResolver from '../utils/img-resolver';
import moment from 'moment';
import 'moment-timezone';
import withRouter from '../utils/with-router';

import TextRenderer from '../components/TextRenderer';

import CertificateStore from '../stores/CertificateStore';
import RecommendationLetterStore from '../stores/RecommendationLetterStore';
import HiringStore from '../stores/HiringStore';
import LoadingView from '../components/LoadingView';
import MessageModal from '../components/MessageModal';
import DeclineModal from '../components/DeclineModal';

import connectToStores from 'alt/utils/connectToStores';

@connectToStores
@withRouter
class ShiftCandidatesProfile extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showMessageModal: false,
            showDeclineModal: false,
            hiringInProgress: null, // gets timestamp when you press button
            hiringInProgressStatus: null,
            messages: [],
            activeCandidate: props.candidate && props.candidate.id,
        };

        if (this.state.activeCandidate !== null) {
            CertificateStore.getCertificates(this.state.activeCandidate);
            RecommendationLetterStore.getRecommendationLetters(this.state.activeCandidate);
        }
    }

    static getPropsFromStores() {
        return {
            cStore: CertificateStore.getState(),
            rlStore: RecommendationLetterStore.getState(),
            hStore: HiringStore.getState()
        };
    }

    static getStores() {
        return [CertificateStore, RecommendationLetterStore, HiringStore];
    }

    componentWillReceiveProps(nextProps) {
        const newState = {
            messages: nextProps.messages
        };
        // Candidate changed
        if ( nextProps.candidate && nextProps.candidate.id !== this.state.activeCandidate ) {
            const newId = nextProps.candidate.id;
            newState['activeCandidate'] = newId;
            CertificateStore.getCertificates(newId);
            RecommendationLetterStore.getRecommendationLetters(newId);
        }

        // Check if hiring request was fired
        if ( this.state.hiringInProgress !== null ) {
            if ( nextProps.hiringStore.hiringError !== null ) {
                newState.hiringInProgress = null;
                newState.hiringInProgressStatus = null;
                this.props.changeCandidateStatus('cancelled');
            }
            if ( nextProps.hiringStore.success !== null ) {
                newState.hiringInProgress = null;
                newState.hiringInProgressStatus = null;
                this.props.changeCandidateStatus(this.state.hiringInProgressStatus);
            }
        }
        this.setState(newState);
    }

    shouldShowChat(shift, hiring) {
        if ([DJ_CONST.SHIFT_STATUSES.CANCELLED, DJ_CONST.SHIFT_STATUSES.ENDED, DJ_CONST.SHIFT_STATUSES.FINISHED].indexOf(shift.status) >= 0) {
            return false;
        } else if (!hiring) {
            return false;
        } else if ([DJ_CONST.HIRING_STATUSES.HIRED].indexOf(hiring.status) >= 0) {
            return true
        } else if ([DJ_CONST.HIRING_STATUSES.CANCELLED, DJ_CONST.HIRING_STATUSES.CANCELLED_BY_US].indexOf(hiring.status) >= 0) {
            return false;
        }

        return shift.chat;
    }

    getCertificates() {
        const certificates = this.props.cStore.certificates || {};
        let user_certificates = [];
        if ( certificates.length > 0 ) {
            user_certificates.push(<div className="section-title">Certificates</div>);
        }
        certificates.forEach(certificate => {
            user_certificates.push(
                <div key={certificate.id} className="certificate">
                    <div><b><a href={certificate.file} download>{certificate.name}</a></b> - {moment(certificate.start_date).format('D. MMM YYYY')}</div>
                    <div>{certificate.description}</div>
                </div>
            );
        });

        return user_certificates;
    }

    getRecommendationLetters() {
        const recommendation_letters = this.props.rlStore.recommendation_letters || {};
        let user_recommendations = [];
        recommendation_letters.forEach(recommendation => {
            user_recommendations.push(
                <p key={recommendation.id}><b>Letter of recommendation - </b> <a className="link-letter" href="{recommendation.file}">{recommendation.file}</a></p>
            );
        });

        return user_recommendations;
    }

    getLanguages(languages) {
        let user_languages = [];
        if ( languages.length > 0 ){
            user_languages.push(<div className="section-title">Languages</div>);
        }

        languages.forEach(lang => {
            user_languages.push(
               <div key={lang.id} className="language">
                    <span><b>{lang.language}</b> - {lang.skill}</span>
                </div>
            );
        });

        return user_languages;
    }

    getProfilePicture(profile_picture) {
        if (profile_picture) {
            return <div className="candidate-header-avatar" style={{backgroundImage: 'url('+profile_picture+')'}}></div>;
        } else {
            return <div className="candidate-header-avatar" style={{backgroundImage: 'url(' + require('../styles/images/team_member.png') + ')'}}></div>
        }
    }

    hireCandidate(status, message) {
        if ( this.state.hiringInProgress !== null ) {
            return false;
        }

        this.setState({
            hiringInProgress: new Date().getTime() / 1000,
            hiringInProgressStatus: status
        });

        HiringStore.changeStatus(this.props.candidate.hiring.id, {status, message});
    }

    toggleMessageModal() {
        this.setState({
            showMessageModal: !this.state.showMessageModal
        });
    }

    renderExperienceArea() {
        const candidate = this.props.candidate || {languages: undefined, hiring: {}, user: {}, current_company: {}};
        const elements = [];

        elements.push(
            <div className="experience-box setwidth">
                <div className="experience-box-content">
                    <div className="gigs-done">{candidate.finished_shifts}</div>
                    <div className="experience-box-text">gigs<br />done</div>
                </div>
            </div>
        );

        elements.push(
            <div className="experience-box setwidth middle">
                <div className="experience-box-content">
                    <div className="gigs-done">{candidate.recommended}</div>
                    <div className="experience-box-text">times<br />recommended</div>
                </div>
            </div>
        );

        elements.push(
            <div className="experience-box setwidth middle">
                <div className="experience-box-content">
                    <div className="gigs-done">{DJ_CONST.LOCALE_CONF.currency} {candidate.recommended_price} / h</div>
                    <div className="experience-box-text">avg. rate when<br />recommended</div>
                </div>
            </div>
        );

        if ( candidate.user.validated ) {
            elements.push(
                <div className="experience-box setwidth">
                    <div className="experience-box-content">
                        <img className="experience-box-icon" src={require('../styles/images/icon_verified.svg')} />
                        <div className="experience-box-text"><br />Verified</div>
                    </div>
                </div>
            );
        }

        return <div className="experience-boxes">{elements}</div>;
    }

    renderChat() {
        const candidate = this.props.candidate || {languages: undefined, hiring: {}, user: {}, current_company: {}};
        const shift = this.props.shift || {};
        const messages = this.state.messages;
        const user = this.props.user || {};

        if (this.shouldShowChat(shift, candidate.hiring)) {
            const sortedMessages = messages.filter(message => {
                return message.hiring == candidate.hiring.id;
            }).sort((a, b) => {
                return moment(b.date) - moment(a.date);
            }).map(message => {
                const msgTimestamp = moment(message.date).tz(shift.company.timezone);
                return (
                    <div className="message">
                        {this.getProfilePicture(message.profile_picture)}
                        <div className="message-content">
                            <div className="name">{message.user_name + (message.sender == user.profile.id ? ' (You)' : '')}</div>
                            <div className="content">{message.message}</div>

                            <div className="message-info">
                                <div className="date">{msgTimestamp.format('D. MMM YYYY')}</div>
                                <div className="time">{msgTimestamp.format('h:mm A')}</div>
                            </div>
                        </div>
                    </div>
                );
            });

            return [1, 2].map(id => {
                if ( id == 1 && sortedMessages.length > 0 ){
                    return (
                        <div className="candidate-chat">
                            {sortedMessages}
                        </div>
                    );
                } else {
                    return <MessageModal shiftId={shift.id} hiringId={candidate.hiring.id} user={user} toggleModal={this.toggleMessageModal.bind(this)} isVisible={this.state.showMessageModal} />;
                }
            });
        }
    }

    toggleDeclineModal() {
        this.setState({showDeclineModal: !this.state.showDeclineModal});
    }

    declineCandidate(candidate) {
        if (candidate.hiring.status === 'hired') {
            this.toggleDeclineModal();
        } else {
            this.hireCandidate('declined', null)
        }
    }

    renderCandidateButtons(shift, candidate) {
        if (['finished', 'cancelled'].indexOf(shift.status) >= 0 ) {
            return null;
        }

        const buttons = [];

        if (this.shouldShowChat(shift, candidate.hiring)) {
            buttons.push(<button onClick={this.toggleMessageModal.bind(this)} className="btn btn-green btn-small">Send a message</button>);
        }

        if ( candidate.hiring.status == 'pending' && shift.workers_needed > shift.candidates_hired ) {
            let classNames = 'btn btn-small';
            if ( this.state.hiringInProgress !== null ) {
                classNames += ' btn-disabled';
            }
            buttons.push(<button onClick={this.hireCandidate.bind(this, 'hired', null)} className={classNames}>Hire</button>);
        }

        buttons.push(<button onClick={this.declineCandidate.bind(this, candidate)} className="btn btn-small">Decline</button>);

        return (
            <div className="candidate-buttons">
                {buttons}
                <button className="btn btn-small back" onClick={this.props.closeCandidate}>Back</button>
            </div>
        );
    }

    render () {
        const candidate = this.props.candidate;
        const shift = this.props.shift;
        if (!shift || !candidate) {
            return <LoadingView />;
        }

        return (
            <div className={`shift-candidate body ${this.props.candidateHidden ? 'hidden' : ''}`}>

                <div className="candidate-header">
                    <div className="candidate-header-info">
                        {this.getProfilePicture(candidate.user.profile_picture)}
                        <div className="candidate-header-text">
                            <h1>{candidate.user.first_name} {candidate.user.last_name}</h1>
                            <p>{shift.position_name} ({(candidate.sex == 'm' ? 'Male' : 'Female')})</p>
                            <p>{candidate.city}, {candidate.country}</p>
                            <p>Age: {candidate.age}</p>
                        </div>
                    </div>

                    <div className="candidate-header-cash">
                        <span>{DJ_CONST.LOCALE_CONF.currency} {candidate.hiring.price} / h</span>
                        <i className="icon-money" />
                    </div>
                    <button className="btn btn-small back" onClick={this.props.closeCandidate}>Back</button>
                </div>

                <div className="candidate-content">
                    <div className="section-title">Bio</div>
                    <TextRenderer content={candidate.bio} />
                    <div className="section-title">Experience</div>
                    {this.renderExperienceArea()}
                    {this.getCertificates()}
                    {this.getRecommendationLetters()}
                    {this.getLanguages(candidate.languages)}
                </div>
                {this.renderChat()}
                {this.renderCandidateButtons(shift, candidate)}
                <DeclineModal isVisible={this.state.showDeclineModal}
                              toggleModal={this.toggleDeclineModal.bind(this)}
                              declineCandidate={this.hireCandidate.bind(this)}
                              candidateName={`${candidate.user.first_name} ${candidate.user.last_name}`} />
            </div>
        );
    }
}

export default ShiftCandidatesProfile;



/** WEBPACK FOOTER **
 ** ./app/src/components/ShiftCandidatesProfile.js
 **/